import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AddCommunityMember from "../addCommunityMember/AddCommunityMember";
import Header from "../header/Header";
import axios from "axios";
import moment from "moment";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./AppointmentBook.css";
import OkayModal from "../programDetailModals/OkayModal";

const AppointmentBook = (props) => {
  const navigate = useNavigate();
  const userMainTherapist = localStorage.getItem("userMainTherapist")
    ? JSON.parse(localStorage.getItem("userMainTherapist"))
    : 0;

  const [subStep, setSubstep] = useState(1);
  const [timeSlotsAval, setTimeSlotsAval] = useState([]);
  const [skipOneToOne, setSkipOneToOne] = useState(false);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [bookAppointmentError, setBookAppointmentError] = useState(null);
  const NO_SLOTS_MODAL_TEXT="We are having trouble retrieving open slots for our physical therapists, we will email you as soon as we fix the issue."

  useEffect(() => {
    if (props.disableOneToOne === true || props.allQuestions.disable_oneonone === 1) {
      //setSubstep(3);
      setSkipOneToOne(true);
      navigate("/landing");
    }
  }, [props]);

  const [openModal, setOpenModal] = useState(null);

  function handleOkay(){
    setSkipOneToOne(true);
    navigate("/landing");
  }

  useEffect(() => {
    var newDt = new Date();
    newDt.setHours(0);
    newDt.setMinutes(0);
    newDt.setSeconds(0);
    newDt.setMilliseconds(0);
    getAppointmentSlots(moment(newDt).format("l"));
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const userId = JSON.parse(localStorage.getItem("userData")).id;
      axios.post(window.ajaxLink + "notifications/sendRemindEmailToBookAppointment", {
        userId: userId
      });
      setShowLeaveModal(true);
      setPendingNavigation(event);
      event.preventDefault();
    };

    window.addEventListener("beforeunload", handleBeforeUnload)
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const cancelLeave = () => {
    setShowLeaveModal(false);
    setPendingNavigation(null);
  };

  const preventDefaultNavigation = (event) => {
    event.preventDefault();
    event.returnValue = ""; 
  };

  const confirmLeave = () => {
    setShowLeaveModal(false);
    if (pendingNavigation) {
      // Allow navigation to proceed
      window.removeEventListener("beforeunload", preventDefaultNavigation);
      window.location.href = pendingNavigation.target.href || window.location.href;
    }
  };

  let dateToday = new Date();
  dateToday.setHours(0);
  dateToday.setMinutes(0);
  dateToday.setSeconds(0);
  dateToday.setMilliseconds(0);
  const [revealTimeSlots, setRevealedTimeSlots] = useState(false);
  const [timeSlotSelected, setTimeSlotSelected] = useState("");
  const [resourceSelected, setResourceSelected] = useState("");
  const [selectedTimeSpan, setSelectedTimeSpan] = useState(0);
  const [slotsLoaded, setSlotsLoaded] = useState(false);
  const [errorMsg, setErrorMsg] = useState();
  let dateShow = moment(dateToday).format("l");
  const [appointDate, setDate] = useState(dateShow);


  const updateDate = (newDate) => {
    setErrorMsg();
    setSlotsLoaded(false);
    setDate(moment(newDate).format("l"));

    if (newDate.toISOString() >= dateToday.toISOString()) {
      getAppointmentSlots(moment(newDate).format("l"));
      setTimeSlotSelected("");
      setResourceSelected("");
      setSelectedTimeSpan(0);
    } else {
      setRevealedTimeSlots(false);
      setTimeSlotSelected("");
      setResourceSelected("");
      setSelectedTimeSpan(0);
    }
  };

  const handleTimeSlots = (slot) => {
    if (timeSlotSelected === slot.start) {
      setTimeSlotSelected("");
      setResourceSelected("");
      setSelectedTimeSpan(0);
    } else {
      setTimeSlotSelected(slot.start);
      setResourceSelected(slot.resources[0]);
      setSelectedTimeSpan(slot.slotDuration);
    }
  };

  const [topic, setTopic] = useState("");
  const [reminder, setReminder] = useState("1");
  const handleReminder = () => {
    if (reminder === "0") {
      setReminder("1");
    } else if (reminder === "1") {
      setReminder("0");
    }
  };

  const nextStepToComm = () => {
    setSubstep(3);
    props.setStepsCompleted(4);
    props.setHideHeader(true);
  };

  const [questionnaireId, setQuestionnaireId] = useState(0);
  const [bookingAppt, setBookingAppt] = useState(false);
  const bookAppointment = async() => {
    setBookAppointmentError(null);
    setBookingAppt(true)
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "appointments/createNewInitialAppointment", {
        appointmentDate: moment(timeSlotSelected).utc().format("l"),
        appointmentTime: moment(timeSlotSelected).utc().format("HH:mm"),
        appointmentDuration: selectedTimeSpan,
        appointmentDetails: topic,
        appointmetnPainScaleLevel: props.painScale / 10 || 0,
        //appointmentTopic: "",
        appointmentReminder: reminder,
        resourceId: resourceSelected.id,
      })
      .then((res) => {
        if (res.data.responseData) {
          //setSubstep(3);
          navigate("/landing");
          //props.setHideHeader(true);
          axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
          axios
            .post(window.ajaxLink + "cloud_questionnaires/find-questionnaire", {})
            .then((res) => {
              if (res.data.responseData.questionnaire_id) {
                setQuestionnaireId(res.data.responseData.questionnaire_id);
              }
            })
            .catch((error) => {
              console.error(error);
            });
        }
      })
      .catch((error) => {
        console.error(error);
        setBookAppointmentError(error?.response?.data?.errorData || "An error occurred. Please try again.");
      }).finally(
        setBookingAppt(false)
      );
  };

  const popupRefErr = useRef(errorMsg);
  useEffect(() => {
    popupRefErr.current = errorMsg;
    const timeout = setTimeout(() => {
      setErrorMsg("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorMsg]);
  const getAppointmentSlots = (appointDateS) => {
    var businessId = localStorage.getItem("business_register") ? localStorage.getItem("business_register") : 0;

    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "appointments/getInitialFreeAppointments", {
        appointmentDate: moment(appointDateS).format("l"),
        businessId: businessId,
        therapist_id: userMainTherapist || 0,
      })
      .then((res) => {
        if (res.data.responseData) {
          var allSlots = [];
          var tomorrowDate = new Date(appointDateS);
          tomorrowDate.setDate(tomorrowDate.getDate() + 1);
          tomorrowDate.setHours(0);
          tomorrowDate.setMinutes(0);
          tomorrowDate.setSeconds(0);
          tomorrowDate.setMilliseconds(0);

          for (var oSlot of res.data.responseData) {
            if (
              new Date(oSlot.start) >=
                new Date(new Date() > new Date(appointDateS) ? new Date() : new Date(appointDateS)) &&
              new Date(oSlot.start) < tomorrowDate
            ) {
              allSlots.push(oSlot);
            }
          }

          setTimeSlotsAval(allSlots);
          setRevealedTimeSlots(true);
          setSlotsLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.responseCode === 417) {
          if(error.response.data.errorData === "You have no licensed therapists with valid licenses for your country."){
            setSlotsLoaded(true);
            setOpenModal(NO_SLOTS_MODAL_TEXT);
          }
          if (error.response.data.errorData === "Too Many Requests") {
            setSlotsLoaded(true);
            setErrorMsg("Too many requests. Please wait some time and try again.");
          }
          console.error(error.response.data.errorData);
          if (error.response.data.errorData === "You have no licensed therapists for your country.") {
            setSlotsLoaded(true);
            setErrorMsg("You have no licensed therapists for your country.");
          }
          setTimeSlotsAval([]);
        }
      });
  };

  const backToBookAppointment = () => {
    setSubstep(2);
    props.setHideHeader(false);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      const confirmationMessage = "You are about to Lose Data.";
      event.returnValue = confirmationMessage;
      return confirmationMessage;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      {subStep === 3 ? (
        <AddCommunityMember
          fromAppointmentBook={true}
          questionnaireId={props.questionnaireId}
          backToBook={backToBookAppointment}
          bookAppointmentFromComm={bookAppointment}
          disableOneToOne={skipOneToOne}
        />
      ) : (
          <>
            <div onMouseEnter={() => setShowLeaveModal(true)}>
              <Header inQuestionnaire={true} questionsNum={4} questionsDone={4} />
            </div>
          <div className="ab_hold">
            <>
              <div className="ab_title">
                Get Closer to Recovery! Book Your Appointment with a VirdioHealth Physical Therapist Now!
              </div>
              <div className="ab_desc">
                Get your health on track! Make an appointment with a physical therapist for an individualized treatment
                plan and start your path to recovery today!
              </div>
            </>
            {subStep === 1 && (
              <div className="ab_cali_and_slots_hold">
                <div className="ab_csh_title csh_title_top">Select a date</div>
                <div className="ab_cali_hold calendarContainer">
                  <Calendar
                    onChange={updateDate}
                    defaultValue={new Date(appointDate)}
                    calendarType={"ISO 8601"}
                    view={"month"}
                    minDate={new Date()}
                  />
                </div>
                <div className="ab_csh_title">Select a time</div>
                {slotsLoaded ? (
                  <div>
                    {revealTimeSlots ? (
                      timeSlotsAval.length > 0 ? (
                        <div className="ab_timeslots">
                          {timeSlotsAval.map((slot, s) => (
                            <div
                              key={s}
                              className={
                                "ab_single_timeslot" +
                                (timeSlotSelected === slot.start ? " timeslot_border_selected" : "")
                              }
                              onClick={() => handleTimeSlots(slot)}>
                              <div className="ab_timeslot_time">{moment(slot.start).format("LT")}</div>
                              {timeSlotSelected === slot.start ? (
                                <div className="timeslot_selected">
                                  <div className="timeslot_checked"></div>
                                </div>
                              ) : (
                                <>
                                  <div className="ab_timeslot_icon"></div>
                                  <div className="ab_timeslot_timespan">{slot.slotDuration} min</div>
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="ab_timeslots ab_empty_timeslots">
                          <div className="empty_timeslots_notif">
                            {errorMsg ? errorMsg : "No available time slots for this date"}
                          </div>
                        </div>
                      )
                    ) : (
                      <div className="ab_timeslots ab_empty_timeslots">
                        <div className="empty_timeslots_notif">Select a date above to view available time slots</div>
                      </div>
                    )}
                    {!!appointDate && !!timeSlotSelected && (
                      <div className="ab_empty_timeslots ab_time_success">
                        <div className="ab_success_side">
                          <div className="ab_success_icon ab_lside_icon"></div>
                          {moment(timeSlotSelected).format("LT")} &#45;{" "}
                          {moment(timeSlotSelected)
                            .set({
                              minute:
                                moment(timeSlotSelected).format("LT").split(":")[1].split(" ")[0] == "00"
                                  ? 30
                                  : moment(timeSlotSelected).format("LT").split(":")[1].split(" ")[0] == "30"
                                  ? 60
                                  : "",
                            })
                            .format("LT")}{" "}
                          &#x2022; {selectedTimeSpan} min
                        </div>
                        <div className="ab_success_side">
                          <div className="ab_success_icon ab_rside_icon"></div>
                          {moment(appointDate).format("dddd, MMMM Do, YYYY")}
                        </div>
                      </div>
                    )}
                    <div
                      className={
                        "next_btn_questionare ab_btn" +
                        (!!appointDate && !!timeSlotSelected ? "" : " quest_procc_disabled")
                      }
                      onClick={() => (!!appointDate && !!timeSlotSelected ? setSubstep(2) : "")}>
                      Continue
                    </div>
                  </div>
                ) : (
                  <div className="p_load"></div>
                )}
              </div>
            )}
            {subStep === 2 && (
              <div className="ab_cali_and_slots_hold">
                <div className="ab_additional_hold">
                  <div className="ab_details">
                    <div className="ab_dets_immutable">Appointment Details</div>
                    <div className="ab_success_row">
                      <b>Therapist:</b> {resourceSelected.name}
                      <br />
                      <br />
                      <div className="ab_success_icon ab_lside_icon"></div>
                      {moment(timeSlotSelected).format("LT")} &#45;{" "}
                      {moment(timeSlotSelected)
                        .set({
                          minute:
                            moment(timeSlotSelected).format("LT").split(":")[1].split(" ")[0] == "00"
                              ? 30
                              : moment(timeSlotSelected).format("LT").split(":")[1].split(" ")[0] == "30"
                              ? 60
                              : "",
                        })
                        .format("LT")}{" "}
                      &#x2022; {selectedTimeSpan} min
                    </div>
                    <div className="ab_success_row">
                      <div className="ab_success_icon ab_rside_icon"></div>
                      {moment(appointDate).format("dddd, MMMM Do, YYYY")}
                    </div>
                  </div>
                  <div className="ab_discussion_title">
                    Any additional information you would like to share prior to your appointment?
                  </div>
                  <textarea
                    placeholder={"Enter Message"}
                    value={topic}
                    className="ab_textbox"
                    onChange={(e) => setTopic(e.target.value)}
                    maxLength={100}></textarea>
                  <div className="ab_reminder_hold">
                    <div className="ab_reminder_text">Remind me</div>
                    <div
                      className={"abr_switch " + (reminder === "1" ? "abr_switch_active" : "abr_switch_inactive")}
                      onClick={() => handleReminder()}>
                      <div></div>
                    </div>
                  </div>
                  {bookAppointmentError && 
                  <div style={{color: 'red'}}>{bookAppointmentError}</div>
                  }
                  <div
                    className={
                      "next_btn_questionare ab_btn" +
                      (!!appointDate && !!timeSlotSelected && !bookingAppt ? "" : " quest_procc_disabled")
                    }
                    aria-disabled={bookingAppt}
                    onClick={() => (!!appointDate && !!timeSlotSelected && !bookingAppt ? bookAppointment() : "")}>
                      {bookingAppt ? "Booking Appointment..." : "Book Appointment"}
                  </div>
                    <div className={"next_btn_questionare ab_btn ab_back"} onClick={() => setSubstep(1)}>
                    Back
                  </div>
                </div>
              </div>
            )}
          </div>
          {errorMsg && (
            <div className="prog_err_hold">
              <div className="prog_err_icon"></div>
              <div className="prog_err_text">{errorMsg}</div>
            </div>
          )}
            {showLeaveModal && (
              <div className="dlt_wrapper">
                <div className="dbl_place_on_page">
                  <div className="dlt_surround ">
                    <div className="dlt_title"> Wait! Don’t Miss Your Telehealth Assessment!</div>
                    <div className="dlt_description">It looks like you’re about to leave without booking your initial telehealth assessment. Completing your assessment is the first step towards your personalized recovery plan and better health.Would you like to book your assessment now?</div>
                    <div className="dlt_exit_btm">
                      <div className="dlt_exit_btn dlt_eb_first" onClick={() => confirmLeave()}>
                        No, Thanks
                      </div>
                      <div className="dlt_exit_btn dlt_eb_scnd" onClick={() => cancelLeave()}>
                        Yes, Book Now
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </>
      )}
      <OkayModal title={openModal} openModal={openModal ? true : false} handleOkay={handleOkay} />
    </>
  );
};

export default AppointmentBook;
